<template>
  <div class="campaign-form-container">
    <v-container>
      <v-layout row class="padding">
        <v-flex xs4 sm12 offset-sm3>
          <v-card
            class="mx-auto mt-4 pa-5 text-center text-no-wrap"
            max-width="1000"
            id="limited-products"
          >
            <div class="text-dash">
              <h1>Business Dashboard</h1>
            </div>
            <div class="dashboard">
              <router-link to="#" class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                    <div class="count-c">
                      <h2>{{loginToday}}</h2>
                    </div>
                  </div>
                  <h3>Login (Today)</h3>
                </div>
              </router-link>
              <router-link to="#" class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                     <div class="count-c">
                      <h2>{{uniqueLoginToday}}</h2>
                    </div>
                  </div>
                  <h3>Unique Login (Today)</h3>
                </div>
              </router-link>
              <router-link to="#" class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                     <div class="count-c">
                      <h2>{{loginThisMonth}}</h2>
                    </div>
                  </div>
                  <h3>Login (This Month)</h3>
                </div>
              </router-link>
              <router-link to="#" class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                     <div class="count-c">
                      <h2>{{uniqueLoginThisMonth}}</h2>
                    </div>
                  </div>
                  <h3>Unique Login (This Month)</h3>
                </div>
              </router-link>
              <router-link to="#" class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                   <div class="count-c">
                      <h2>{{updateDay}}</h2>
                    </div>
                  </div>
                  <h3>Users updated data in any module (Today)</h3>
                </div>
              </router-link>
              <router-link to="#" class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                    <div class="count-c">
                      <h2>{{updateMonth}}</h2>
                    </div>
                  </div>
                  <h3>Users updated data in any module (This Month)</h3>
                </div>
              </router-link>
              <router-link to="#" class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                     <div class="count-c">
                      <h2>{{useruploadedD}}</h2>
                    </div>
                  </div>
                  <h3>Users uploaded file in KeepSafe (Today)</h3>
                </div>
              </router-link>
              <router-link to="#" class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                     <div class="count-c">
                      <h2>{{useruploadedM}}</h2>
                    </div>
                  </div>
                  <h3>Users uploaded file in KeepSafe (This Month)</h3>
                </div>
              </router-link>
              <router-link to="#" class="card-icon">
              <div class="card-icon">
                <div class="card-icon-body">
                  <div class="card-icon-i">
                    <div class="count-c">
                      <h2>{{mostvisitedcountM}}</h2>
                    </div>
                  </div>
                  <h3>Most visited page by users for the month (<span style="color:#f90">{{mostvisitedsectionM}}</span>)</h3>
                </div>
              </div>
              </router-link>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    loginToday:'',
    updateDay:'',
    updateMonth:'',
    uniqueLoginToday:'',
    loginThisMonth:'',
    uniqueLoginThisMonth:'',
    useruploadedD:'',
    useruploadedD:'',
    useruploadedM:'',
    usersvisited:'',
    mostvisitedcountM:'',
    mostvisitedsectionM:''
  }),
  methods: {},
  mounted() {
    this.$loading(false);
    axios
      .get(process.env.VUE_APP_ROOT_API + "business-dashboard-user-count" , {
      })
      .then((response) => {
        this.loginToday = response.data.data.loginToday;
        this.uniqueLoginToday = response.data.data.uniqueLoginToday;
        this.loginThisMonth = response.data.data.loginThisMonth;
        this.uniqueLoginThisMonth = response.data.data.uniqueLoginThisMonth;
        this.updateDay = response.data.data.updateDay;
        this.updateMonth = response.data.data.updateMonth;
        this.useruploadedD = response.data.data.useruploadedD;
        this.useruploadedM = response.data.data.useruploadedM;
        this.mostvisitedcountM = response.data.data.mostvisitedM.count;
        this.mostvisitedsectionM = response.data.data.mostvisitedM.event;
        console.log("kjbh",this.mostvisitedsectionM);
      });
  },
};
</script>
<style>

</style>